import React, { DispatchWithoutAction, FC, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { fc } from 'i18n';
import Button from 'core/react/general/form/Button';
import { ModalWrapper } from 'components/molecules/modal-wrapper';
import { monitoredVehiclesSelector } from 'core/redux/selectors/monitoredVehicles';

import styles from './styles.module.css';

interface IConfirmModalProps {
  close: DispatchWithoutAction;
  deleteVehicle: DispatchWithoutAction;
}

export const ConfirmModal: FC<IConfirmModalProps> = ({ close, deleteVehicle }) => {
  const { pending } = useSelector(monitoredVehiclesSelector);

  const loadingRef = useRef(false);

  const onConfirm = () => {
    deleteVehicle();
    loadingRef.current = true;
  };

  useEffect(() => {
    if (!pending && loadingRef.current) {
      loadingRef.current = false;

      close();
    }
  }, [pending]);

  return (
    <ModalWrapper>
      <div className={styles.content}>
        <div className={styles.text}>{fc('are you sure you want to delete asset?')}</div>
        <div className={styles.buttons}>
          <Button type="button" onClick={close}>
            {fc('cancel')}
          </Button>
          <Button type="button" loading={pending} onClick={onConfirm}>
            {fc('okay')}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};
